import createActionConstants from 'lib/create-action-constants'

export const constants = createActionConstants('login', [
  'SET_MODE',
  'SET_CHECKOUT_INTENT',
  'SET_REGISTER_STEP',
  'SET_LOGIN_STEP',
  'SET_RESET_PASSWORD_TOKEN',
  'TOGGLE_PRIVACY_AGREED',
  'SET_FIELD',
  'SET_PASSWORD_POLICY',
  'SET_LOGIN_ERROR',

  'SUBMIT',
  'SUBMIT_SUCCESS',
  'SUBMIT_FAILURE',

  'RESEND_VERIFICATION_EMAIL',
  'RESEND_VERIFICATION_EMAIL_SUCCESS',

  'FETCH_SIGNUP_TYPE',
  'FETCH_SIGNUP_TYPE_SUCCESS',
  'FETCH_SIGNUP_TYPE_FAILURE',
  'FLUSH_SIGNUP_TYPE',

  'SET_USER_SIGNUP_TYPE',
  'SET_USER_SIGNUP_ORG',

  'RESET_LOGIN_MODAL_STATE'
])

export const setMode = mode => ({
  type: constants.SET_MODE,
  payload: mode
})

// Remembers which plan a logged-out user picked from /pricing so the post-register
// flow can resume the correct checkout instead of defaulting everyone to Basic.
// Shape: { plan, annual, quantity }.
export const setCheckoutIntent = intent => ({
  type: constants.SET_CHECKOUT_INTENT,
  payload: intent
})

export const setRegisterStep = registerStep => ({
  type: constants.SET_REGISTER_STEP,
  payload: registerStep
})

export const setLoginStep = loginStep => ({
  type: constants.SET_LOGIN_STEP,
  payload: loginStep
})

export const togglePrivacyAgreed = () => ({
  type: constants.TOGGLE_PRIVACY_AGREED
})

export const setField = (field, value, error) => ({
  type: constants.SET_FIELD,
  payload: {
    field,
    value
  },
  error
})

export const setPasswordPolicy = passwordPolicy => ({
  type: constants.SET_PASSWORD_POLICY,
  payload: {
    ...passwordPolicy
  }
})

export const setLoginError = loginError => ({
  type: constants.SET_LOGIN_ERROR,
  payload: loginError
})

export const submit = (mode, fields, history) => ({
  type: constants.SUBMIT,
  payload: {
    mode,
    fields,
    history
  }
})

export const resendVerificationEmail = email => ({
  type: constants.RESEND_VERIFICATION_EMAIL,
  payload: {
    email
  }
})

export const fetchSignupType = email => ({
  type: constants.FETCH_SIGNUP_TYPE,
  payload: {
    email
  }
})

export const flushSignupType = () => ({
  type: constants.FLUSH_SIGNUP_TYPE
})

export const setUserSignupType = signupType => ({
  type: constants.FETCH_SIGNUP_TYPE_SUCCESS,
  payload: {
    signupType
  }
})

export const setUserSignupTypeOrg = signupOrg => ({
  type: constants.FETCH_SIGNUP_TYPE_SUCCESS,
  payload: {
    signupOrg
  }
})

export const resetLoginModalState = () => ({
  type: constants.RESET_LOGIN_MODAL_STATE
})
